<template>
    <div>
        <div class="p-fluid p-mt-2 p-ml-4 p-mr-4" @keyup.enter="saveData_Modal('search')">
            <div class="p-formgrid p-grid p-justify-start">
                <div class="p-field p-col-12 p-lg-5 p-mt-2">
                    <label for="organize_name">{{ $t('organize_name') }}</label>
                    <InputText
                        id="organize_name"
                        type="text"
                        v-model="organize_name"
                        ref="TextBox_1_search"
                        @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                        @keyup.right="moveFocus($event, 'TextBox_2_search', 'Button')"
                        @keyup.down="moveFocus($event, 'TextBox_2_search', 'Button')"
                    />
                </div>
                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                    <label for="organizeTypeOptions">{{ $t('organize_type') }}</label>
                    <Dropdown
                        v-model="organizeType_select"
                        :options="organizeTypeOptions"
                        optionLabel="system_name"
                        :filter="true"
                        :placeholder="$t('placeholderSelectBox')"
                        :showClear="true"
                        :clearFilterDropdown="dropdownClearFilerValue"
                    >
                        <template #value="organizeTypeOptions">
                            <div v-if="organizeTypeOptions.value">
                                <div>{{ organizeTypeOptions.value.system_name }}</div>
                            </div>
                            <span v-else>
                                {{ organizeTypeOptions.placeholder }}
                            </span>
                        </template>
                        <template #option="organizeTypeOptions">
                            <div class="EV_disasterOptions">{{ organizeTypeOptions.option.system_name }}</div>
                        </template>
                    </Dropdown>
                </div>
            </div>
            <div class="p-formgrid p-grid p-justify-start">
                <div class="p-field p-col-12 p-lg-3 p-mt-2">
                    <label for="provinceOptions">{{ $t('province') }}</label>
                    <Dropdown
                        v-model="province_select"
                        :options="provinceOptions"
                        optionLabel="province_name"
                        :filter="true"
                        :placeholder="$t('placeholderSelectBox')"
                        :showClear="true"
                        :clearFilterDropdown="dropdownClearFilerValue"
                    >
                        <template #value="provinceOptions">
                            <div v-if="provinceOptions.value">
                                <div>{{ provinceOptions.value.province_name }}</div>
                            </div>
                        </template>
                        <template #option="provinceOptions">
                            <div>{{ provinceOptions.option.province_name }}</div>
                        </template>
                    </Dropdown>
                </div>

                <div class="p-field p-col-12 p-lg-3 p-mt-2">
                    <label for="amphurOptions">{{ $t('amphur') }}</label>
                    <Dropdown
                        :disabled="isDisabledAmphur == 1"
                        v-model="amphur_select"
                        :options="amphurOptions"
                        optionLabel="amphur_name"
                        :filter="true"
                        :placeholder="$t('placeholderSelectBox')"
                        :showClear="true"
                        :clearFilterDropdown="dropdownClearFilerValue"
                    >
                        <template #value="amphurOptions">
                            <div v-if="amphurOptions.value">
                                <div>{{ amphurOptions.value.amphur_name }}</div>
                            </div>
                        </template>
                        <template #option="amphurOptions">
                            <div>{{ amphurOptions.option.amphur_name }}</div>
                        </template>
                    </Dropdown>
                </div>

                <div class="p-field p-col-12 p-lg-3 p-mt-2">
                    <label for="tambonOptions">{{ $t('tambon') }}</label>
                    <Dropdown
                        :disabled="isDisabledTambon == 1"
                        v-model="tambon_select"
                        :options="tambonOptions"
                        optionLabel="tambon_name"
                        :filter="true"
                        :placeholder="$t('placeholderSelectBox')"
                        :showClear="true"
                        :clearFilterDropdown="dropdownClearFilerValue"
                    >
                        <template #value="tambonOptions">
                            <div v-if="tambonOptions.value">
                                <div>{{ tambonOptions.value.tambon_name }}</div>
                            </div>
                        </template>
                        <template #option="tambonOptions">
                            <div>{{ tambonOptions.option.tambon_name }}</div>
                        </template>
                    </Dropdown>
                </div>
                <div class="p-field p-col">
                    <div class="p-formgrid p-grid p-jc-start" id="OMS">
                        <div class="p-col-6 p-lg-4 p-mt-2" style="width: 6rem">
                            <Button
                                @click="searchOrganization()"
                                :label="$t('searchBtn')"
                                class="p-button-info p-mb-2 p-mt-4"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                        <div class="p-col-6 p-lg-4 p-mt-2" style="width: 6rem">
                            <Button
                                @click="selectItem()"
                                :label="$t('selectBtn')"
                                class="p-button-success p-mb-2 p-mt-4"
                                ref="TextBox_3_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Organize -->
        <DataTable
            :value="organizeTable"
            :scrollable="true"
            scrollHeight="500px"
            :paginator="true"
            :rows="10"
            ref="dt"
            :selection.sync="selectOrganization"
            dataKey="organize_id"
            :rowHover="true"
            :filters="filters"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
        >
            <template #empty>{{ $t('TableEmpty') }}</template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="organize_name" :header="$t('organize_name')" :sortable="true" headerStyle="width: 30rem">
                <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                </template>
            </Column>
            <Column field="system_name" :header="$t('organize_type')" :sortable="true" headerStyle="width: 30rem">
                <template #body="dataTable">
                    {{ dataTable.data.system_name }}
                </template>
            </Column>
            <Column field="organize_location" :header="$t('organize_location')" :sortable="true" headerStyle="width: 30rem">
                <template #body="dataTable">
                    {{ dataTable.data.organize_location }}
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
export default {
    name: 'organize-table',
    // props: ["parentmessage"],
    props: {
        parentmessage: Array,
        checkForm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dropdownClearFilerValue: 0,
            isDisabledAmphur: 1,
            isDisabledTambon: 1,
            organize_name: '',
            provinceOptions: [],
            province_select: null,
            amphurOptions: [],
            amphur_select: null,
            tambonOptions: [],
            tambon_select: null,
            organizeTypeOptions: [],
            organizeType_select: null,
            organizeTable: [],
            filters: {},

            selectOrganization: null
        };
    },
    async created() {
        const token = localStorage.getItem('token');

        if (token) {
            const decodedToken = this.decodeJWT(token);

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            await this.axios
                .post(`${this.$url_service}/initial/organize`, {
                    body: {
                        topic: 'get-table',
                        userOrg
                    }
                })
                .then((response) => (this.organizeTable = response.data.data));
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        }
    },

    mounted() {
        this.selectOrganization = this.parentmessage;
    },

    methods: {
        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_2_search') && !this.isFocused('TextBox_3_search')) {
                    this.searchOrganization();
                }
            }
        },
        async searchOrganization() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/organize`, {
                    body: {
                        topic: 'search-table',
                        type: this.organizeType_select,
                        name: this.organize_name,
                        organize: '',
                        province: this.province_select,
                        amphur: this.amphur_select,
                        tambon: this.tambon_select,
                        userOrg
                    }
                })
                .then((response) => (this.organizeTable = response.data.data));
        },
        async searchVolunteerOrganization() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/organize`, {
                    body: {
                        topic: 'search-volunteer-table',
                        type: this.organizeType_select,
                        name: this.organize_name,
                        organize: '',
                        province: this.province_select,
                        amphur: this.amphur_select,
                        tambon: this.tambon_select,
                        userOrg
                    }
                })
                .then((response) => (this.organizeTable = response.data.data));
        },

        selectItem() {
            this.$emit('selectOrganization', this.selectOrganization);
        },

        ChangeData_organize(check) {
            if (check) {
                return this.checkPermission() ? null : this.getUserOrganize();
            } else {
                return null;
            }
        }
    },

    watch: {
        async province_select(val) {
            this.amphur_select = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.province_select.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.isDisabledTambon = 1;
                this.tambon_select = null;
                this.amphur_select = null;
            }
        },

        async amphur_select(val) {
            this.tambon_select = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.amphur_select.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.tambon_select = null;
            }
        }
    }
};
</script>

<style scoped></style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}

@media screen and (max-width: 430px) {
    #OMS {
        justify-content: center;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}
</style>
